import apiService from "./BaseApi";
const ENDPOINT = "consumptions";
import store from '@/store/index'
const ConsumptionService = {
    findBySectors: async (data) => apiService.post(ENDPOINT + "/findBySectors", { currentUserId: store.state.currentUser?.uid, ...data }),
    consumptionBySectorsByTariff: async (data) => apiService.post(ENDPOINT + "/consumptionBySectorsByTariff", { currentUserId: store.state.currentUser?.uid, ...data }),
    findByUnit: async (data) => apiService.post(ENDPOINT + "/findByUnit", { currentUserId: store.state.currentUser?.uid, ...data }),
    consumptionByUnitByTariff: async (data) => apiService.post(ENDPOINT + "/consumptionByUnitByTariff", { currentUserId: store.state.currentUser?.uid, ...data }),
};

export default ConsumptionService;
